import { LuAudioLines, LuVideo, LuImage } from "react-icons/lu"

import SafeImage from "./ui/SafeImage"
import { useShow } from "@/contexts/ShowContext"

export default function AssetThumbnail({asset, className, fit='object-cover', showMediaType=true}){
    const { show } = useShow()

    const thumb = (asset.mediaType === 'image' || asset.mediaType === 'video') && asset.thumbnail_url
        ? asset.thumbnail_url
        : null

    const videoFallback = !thumb && asset.mediaType === 'video' && asset.url

    const getIcon = () =>{
        if(asset.mediaType === 'audio') return <LuAudioLines className='w-1/2 h-1/2 text-secondary-foreground/20' />
        if(asset.mediaType === 'video') return <LuVideo className='w-1/2 h-1/2 text-secondary-foreground/30' />
        if(asset.mediaType === 'image') return <LuImage className='w-1/2 h-1/2 text-secondary-foreground/30' />
    }

    const getCharacter = () => {
        return show?.characters?.find(c => c.voice_ids.some(v => v.voice_id === asset.generation?.settings?.voiceId))
    }

    return (
        <div className={`flex justify-center items-center relative overflow-hidden w-full h-full ${className} ${thumb || videoFallback ? '' : 'bg-card'}`}>
            {thumb && <SafeImage src={thumb} alt={asset.name} fill className={fit} />}
            {videoFallback && <video src={asset.url} preload="metadata" muted playsInline draggable={false} className={`w-full h-full ${fit}`} />}
            {!thumb && !videoFallback && getIcon()}
            {(asset.generation?.settings?.prompt && asset.generation?.settings?.voiceId && asset.mediaType === 'audio') &&
                <div className='absolute inset-0 flex items-center justify-center overflow-hidden p-5 select-none bg-card/80'>
                    <div className='text-[10px] italic text-secondary-foreground/80 max-h-full overflow-y-auto'>
                        <img className='float-left w-8 h-8 rounded-full object-cover mr-2 mb-1' src={getCharacter()?.thumbnail_url} alt={getCharacter()?.name} />
                        {asset.generation?.settings?.prompt}
                    </div>
                </div>
            }
        </div>
    )
}